import styled from 'styled-components';
import Icon from 'ui/atoms/icon';

export const LeftColumn = styled.div`
  flex: 7;
`;

export const RightColumn = styled.div`
  flex: 5;
`;

export const DeleteIcon = styled(Icon)`
  margin-left: 0.5rem;
`;

export const Row = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 4px;
`;
